import { defineComponent as _defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useArticlesStore } from '@/stores/articles.ts';
import { useShortLengthsOverview } from '@/utils/utils';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ArticlesClearAllFilter',
    setup(__props, { expose: __expose }) {
        __expose();
        const { t: $t } = useI18n();
        const route = useRoute();
        const router = useRouter();
        const articleSTore = useArticlesStore();
        const isShortLengthsOverview = useShortLengthsOverview();
        const visible = ref(false);
        watch(() => route.query, async (query, oldQuery) => {
            visible.value = !!(query.grade ||
                query.outerDiameter ||
                query.wallThickness ||
                (query.material && query.shape) ||
                (isShortLengthsOverview.value && (query.material || query.shape)));
        }, { immediate: true });
        const __returned__ = { $t, route, router, articleSTore, isShortLengthsOverview, visible };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
